var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.HeaderStyle),attrs:{"id":"appHeader"}},[_c('h1',{style:(_vm.TitleStyle)},[_vm._v("Colour Converter")]),_c('v-icon',{attrs:{"size":"3rem","color":("hsl(" + _vm.ComplementaryHue + ", 70%, 70%)"),"id":"headerIcon"},on:{"click":function($event){return _vm.$emit('changeColour')}}},[_vm._v(_vm._s(_vm.PaletteIcon))]),_vm._l(([
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19 ]),function(i){return _c('Blob',{key:i,staticClass:"blob",attrs:{"interval":10 + i,"path":_vm.getRandomPath(),"BaseHue":_vm.BaseHue}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }